<div class="controlitem" [attr.title]="setpointDescription" [attr.name]="setpointName">
    <span *ngIf="setpointModel.name" class="controlitem-box {{ setpointModel.name }}"></span>

    <div class="controlitem-text">
        <span *ngIf="isOff()">Off</span>
        <span *ngIf="isEmergencyHeat()">Emergency Heat</span>
        <span *ngIf="isExternal()">Ext.</span>

        <span *ngIf="isFullControl() || isFullControlHeatOnly()">
                    <span class="setpointitem-heating" [ngClass]="{ 'staging-on': !isStagingModeOff(), 'pulsing-content': isHeatingMode() }"></span>
                    <span class="force-space">{{ setpointModel.heatingTemp }}°</span>
                </span>

        <span *ngIf="isFullControl() || isFullControlCoolOnly()">
                    <span class="setpointitem-cooling" [ngClass]="{ 'staging-on': !isStagingModeOff(), 'pulsing-content': isCoolingMode() }"></span>
                    <span class="force-space">{{ setpointModel.coolingTemp }}°</span>
                </span>

        <span class="setpointitem-blower" *ngIf="isBlowerOn()">
                    <mat-icon [ngClass]="getBlowerOnClass()" class="size-to-text top" svgIcon="monitoringFan"></mat-icon>
                </span>
    </div>
</div>
